import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import NavbarApp from "@/components/NavbarApp.vue";
import FormCall from "@/components/FormCall.vue";
import ContentIntro from "@/components/ContentIntro.vue";
import IconSvg from "@/components/IconSvg.vue";
import { uiMapper } from "@/services/store/modules/ui/store";
import { dataMapper } from "@/services/store/modules/data/store";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["formCallIsShown"]),
    },
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(["videoLink"]),
    },
});
let ScreenIntro = class ScreenIntro extends Mixins(UiMappers, DataMappers) {
    openVideo() {
        window.open(this.videoLink, "_blank");
    }
    downClicked() {
        this.$emit("downClicked");
    }
};
ScreenIntro = __decorate([
    Component({
        components: {
            NavbarApp,
            FormCall,
            ContentIntro,
            IconSvg,
        },
    })
], ScreenIntro);
export default ScreenIntro;
